import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Renderer2, Inject, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';
import { AutocompleteService } from '../../Services/autocomplete.service';
import { StripHtmlPipe } from '../../../../pipes/strip-html.pipe';
import { TgSettingsService } from '../../../../services/TG-Setting_Services/tg-settings.service';

@Component({
  selector: 'app-primeng-autocomplete-single-select',
  standalone: true,
  imports: [CommonModule, FormsModule, AutoCompleteModule, StripHtmlPipe],
  templateUrl: './primeng-autocomplete-single-select.component.html',
  styleUrls: ['./primeng-autocomplete-single-select.component.css'],
  encapsulation: ViewEncapsulation.None /* Required for PrimeNG dropdown panels */
})
export class PrimengAutocompleteSingleSelectComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() model: any = { text: '' };
  @Input() placeholder = '';
  @Input() searchType: 'powerSearchKeyWordSearch' | 'powerSearchLocationSearch' = 'powerSearchKeyWordSearch';

  @Output() selected = new EventEmitter<string>();

  @ViewChild('primeAutoComplete', { read: ElementRef }) acRef!: ElementRef;
  TgSettingsData: any = {};
  options: string[] = [];
  loading = false;
  inputId = '';
  a11yAnnouncement = '';
  locationAutoComplete = '/TgNewUI/Search/Ajax/LocationAutoComplete'; // Flag to determine if it's location autocomplete
  // Pagination Variables added
  currentPage = 1;
  pageSize = 10;
  hasMoreData = true;
  isLoadingMore = false;
  currentQuery = ''; 
  private lastQuery: string = '';
private stopFurtherLoad: boolean = false;
  private panelScrollListener: (() => void) | null = null;
  private currentApiSub: Subscription | null = null;

  private subs: Subscription[] = [];

  constructor(
    private autoSvc: AutocompleteService,
    private tgsettings: TgSettingsService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.tgsettings.settings$.subscribe(settings => {
      this.TgSettingsData = settings || {};
      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    this.inputId = this.model?.id || ('ac-single_' + Math.random().toString(36).slice(2));
  
    this.applyThemeVariables(this.tgsettings.getBrandingConfig());
  }

  ngAfterViewInit(): void {
    this.applyAccessibilityFixes();  
  }

  onDropdownClick(): void {
    const currentVal = this.model?.text || '';
    this.search({ query: currentVal });
    
    setTimeout(() => {
      const inputEl = this.acRef?.nativeElement?.querySelector('input');
      if (inputEl) inputEl.focus();
    }, 50);
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
    if (this.currentApiSub) this.currentApiSub.unsubscribe();
    this.onPanelHide(); // Cleanup scroll listener
  }

  private extractText(val: any): string {
    if (!val) return '';
    if (typeof val === 'string') return val;
    return val.LocationName || val.OptionName || val.label || val.value || '';
  }

 search(event: any, isLoadMore: boolean = false): void {

  const queryText = (event?.query || this.model?.text || '').trim();

  // ✅ Reset when query actually changes
  if (queryText !== this.currentQuery) {
    this.stopFurtherLoad = false;
    
    this.currentPage = 1;
    this.hasMoreData = true;
  }

  if (!isLoadMore) {
    this.currentQuery = queryText; // ✅ update AFTER comparison
  } else {
    if (this.stopFurtherLoad) return;
    this.currentPage++;
  }

  if (!isLoadMore && this.currentApiSub) {
    this.currentApiSub.unsubscribe();
  }

  this.loading = true;
  if (isLoadMore) this.isLoadingMore = true;
  if (!isLoadMore) this.announceToScreenReader('Searching...');

  const partnerId = Number((document.getElementById('partnerId') as HTMLInputElement)?.value ?? 0);
  const siteId = Number((document.getElementById('siteId') as HTMLInputElement)?.value ?? 0);
  const token = this.getRftToken();

  // ---------------- KEYWORD ----------------
  if (this.searchType === 'powerSearchKeyWordSearch') {

    const req: any = {
      partnerId,
      siteId,
      searchString: this.currentQuery,
      searchFields: this.TgSettingsData?.tgSettings?.KeywordCustomSolrFields 
     
      
    };

    this.currentApiSub = this.autoSvc.getKeyWordSuggestions(
      req,
      token,
      '/TgNewUI/Search/Ajax/KeywordAutoComplete'
    ).subscribe({
      next: (res: any[]) => {
        this.options = [];
        const newResults = res
          ? res.map(x => this.extractText(x)).filter(x => !!x)
          : [];

        const existingSet = new Set(this.options);
        const uniqueResults = newResults.filter(x => !existingSet.has(x));

       

        this.options = (isLoadMore
          ? [...this.options, ...uniqueResults]
          : uniqueResults)
          .slice(0, 10);

        this.hasMoreData = false;//uniqueResults.length >= this.pageSize;

        this.loading = false;
        this.isLoadingMore = false;
this.applyAccessibilityFixes();

        this.announceToScreenReader(`${this.options.length} results available.`);
      },
      error: () => {
        if (!isLoadMore) this.options = [];

        this.loading = false;
        this.isLoadingMore = false;
        this.hasMoreData = false;
      }
    });

    this.subs.push(this.currentApiSub);
  }

  // ---------------- LOCATION ----------------
  if (this.searchType === 'powerSearchLocationSearch') {

    const req = {
      partnerId,
      siteId,
      searchString: this.currentQuery,
      location: this.currentQuery,
      LocationCustomSolrFields:this.TgSettingsData?.tgSettings?.LocationCustomSolrFields,
      mapProvider: 'None',
      languageISOLetter: this.tgsettings.getLocale() || 'en-GB',
      searchFields: this.TgSettingsData?.tgSettings?.LocationCustomSolrFields     
      
    };

const bMapProvider =
  this.TgSettingsData.tgSettings.ProximitySearch.toLowerCase() === 'yes';
  const hasLocationFields =
  this.TgSettingsData.tgSettings.LocationCustomSolrFields != null &&
  this.TgSettingsData.tgSettings.LocationCustomSolrFields.length > 0;
  if (bMapProvider && hasLocationFields) {

  // Endpoint 1
  this.locationAutoComplete =
    '/TgNewUI/Search/Ajax/LocAutoComplete';

}
else{
  if (bMapProvider) {
    this.locationAutoComplete =
    '/TgNewUI/Search/Ajax/ProximityLocationAutoComplete';
  }
  else{
    this.locationAutoComplete =
    '/TgNewUI/Search/Ajax/LocationAutoComplete';
  }
}
    this.currentApiSub = this.autoSvc.getKeyWordSuggestions(
      req,
      token,
      this.locationAutoComplete
    ).subscribe({
      next: (res: any[]) => {
        this.options = [];
        const newResults = res
          ? res.map(x => this.extractText(x)).filter(x => !!x)
          : [];

        const existingSet = new Set(this.options);
        const uniqueResults = newResults.filter(x => !existingSet.has(x));

        if (isLoadMore && uniqueResults.length === 0) {
          this.stopFurtherLoad = true;
          this.loading = false;
          this.isLoadingMore = false;
          return;
        }

        this.options = (isLoadMore
          ? [...this.options, ...uniqueResults]
          : uniqueResults).slice(0, 10);

        this.hasMoreData = false;

        this.loading = false;
        this.isLoadingMore = false;
this.applyAccessibilityFixes();

        this.announceToScreenReader(`${this.options.length} results available.`);
      },
      error: () => {
        if (!isLoadMore) this.options = [];

        this.loading = false;
        this.isLoadingMore = false;
        this.hasMoreData = false;
      }
    });

    this.subs.push(this.currentApiSub);
  }
}

 

  onPanelShow(): void {
    setTimeout(() => {
      const scrollableContainer = this.document.querySelector('.tg-solid-autocomplete-panel .p-autocomplete-list-container');
      if (scrollableContainer) {
        this.panelScrollListener = this.renderer.listen(scrollableContainer, 'scroll', (e) => {
          const target = e.target;
          if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
           // this.loadMore();
          }
        });
      }
    }, 100);
  }

  onPanelHide(): void {
    if (this.panelScrollListener) {
      this.panelScrollListener();
      this.panelScrollListener = null;
    }
  }
  // -----------------------------------------

  choose(event: any): void {
    const selectedVal = this.extractText(event);
    if (this.model) this.model.text = selectedVal;
    this.selected.emit(selectedVal);
    this.announceToScreenReader(`Selected ${selectedVal}`);
  }

  onBlurHandler(): void {
    const currentVal = this.model?.text;
    const finalVal = typeof currentVal === 'string' ? currentVal.trim() : this.extractText(currentVal);
    if (this.model) this.model.text = finalVal;
    this.selected.emit(finalVal);
  }

  clearInput(): void {
    if (this.model) this.model.text = '';
    this.options = [];
    this.selected.emit('');
    this.announceToScreenReader(
      this.searchType === 'powerSearchKeyWordSearch' ? 'Keyword cleared' : 'Location cleared'
    );
    setTimeout(() => {
      const inputEl = this.acRef?.nativeElement?.querySelector('input.p-autocomplete-input');
      if (inputEl) inputEl.focus();
    }, 50);
  }

  getClearAriaLabel(): string {
    return this.searchType === 'powerSearchKeyWordSearch' ? 'Clear keyword' : 'Clear location';
  }

  private applyAccessibilityFixes() {
    if (!this.acRef) return;

    setTimeout(() => {
       const inputEl = this.acRef.nativeElement.querySelector('input.p-autocomplete-input');
      if (inputEl) {
        this.renderer.setAttribute(inputEl, 'name', this.searchType);
        // Do NOT override 'id' here — PrimeNG already sets it to inputId via [inputId] binding.
        // Overriding it breaks the <label for="..."> association from both the parent
        // power-search template and the component's own sr-only label.
        this.renderer.setAttribute(inputEl, 'aria-labelledby', this.inputId + '_label');
        this.renderer.setAttribute(inputEl, 'aria-describedby', this.inputId + '_desc');
        this.renderer.setAttribute(inputEl, 'class', 'control ng-pristine ng-valid ng-star-inserted ng-touched');
      }

      const dropdownBtn = this.acRef.nativeElement.querySelector('.p-autocomplete-dropdown');
      if (dropdownBtn) {
        this.renderer.setAttribute(dropdownBtn, 'aria-label', 'Open suggestions');
      }
    }, 100);
  }


  private announceToScreenReader(message: string) {
    this.a11yAnnouncement = '';
    setTimeout(() => {
      this.a11yAnnouncement = message;
      setTimeout(() => { this.a11yAnnouncement = ''; }, 3000);
    }, 50);
  }
private fixAutocompletePanelAccessibility() {
  setTimeout(() => {

    const panel = document.querySelector('.p-autocomplete-panel');
    if (!panel) return;

    const options = panel.querySelectorAll('[role="option"]');

    options.forEach((opt: any) => {

      let rawLabel = opt.getAttribute('aria-label');

      if (rawLabel) {

        // ✅ Step 1: Decode HTML entities
        const txt = document.createElement('textarea');
        txt.innerHTML = rawLabel;
        let decoded = txt.value;

        // ✅ Step 2: Strip HTML tags
        decoded = decoded.replace(/<[^>]*>/g, '');

        // ✅ Step 3: Trim
        decoded = decoded.trim();

        // ✅ Step 4: Set clean label
        opt.setAttribute('aria-label', decoded);
      }

    });

  }, 300);
}
  private getRftToken(): string {
    return ((document.querySelector("input[name='__RequestVerificationToken']") as HTMLInputElement)?.value || '');
  }

private applyThemeVariables(styles: any) {
    const root = this.document.documentElement; 

    // Base theme
    root.style.setProperty('--tg-bg', styles?.bg );
    root.style.setProperty('--tg-text', styles?.text );
    root.style.setProperty('--tg-focus', styles?.focus );
    root.style.setProperty('--tg-font', styles?.font );
    root.style.setProperty('--tg-font-size', styles?.fontSize );

    // Interactive states
    root.style.setProperty('--tg-hover-bg', styles?.hoverBg );
    root.style.setProperty('--tg-active-text', styles?.activeText );
    root.style.setProperty('--tg-active-border', styles?.activeBorder );

    // Input / control specific
    root.style.setProperty('--tg-input-bg', styles?.inputBg || styles?.bg );
    root.style.setProperty('--tg-border-color', styles?.borderColor || styles?.text);
    root.style.setProperty('--tg-border-radius', styles?.borderRadius );

    // Layout
    root.style.setProperty('--tg-control-height', styles?.controlHeight );
    root.style.setProperty('--tg-control-max-width', styles?.controlMaxWidth );

    // Component specific
    root.style.setProperty('--tg-header-bg', styles?.headerBg || styles?.bg );
    root.style.setProperty('--tg-chip-bg', styles?.chipBg || styles?.hoverBg );
    root.style.setProperty('--tg-disabled-color', styles?.disabledColor );

    
  }
}
